import { render, staticRenderFns } from "./Demander.vue?vue&type=template&id=5598cd2c&scoped=true"
import script from "./Demander.vue?vue&type=script&lang=js"
export * from "./Demander.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5598cd2c",
  null
  
)

export default component.exports